import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from 'app/spacing';
import PerformKizenStepper from '__pages/Common/bulkactions/stepper';
import { PageToolbarTitle } from 'components/Layout/PageToolbar';
import { getErrorComoponents } from '__components/CatchError/CatchError';
import { ErrorMessage } from '__components/ErrorMessage';
import { BusinessGenerationSummary } from 'ts-components/BusinessGenerationSummary';
import { getSettingsAccess } from 'store/authentication/selectors';
import { BusinessBuilderContainer, Header, StepperWrapper } from './styles';
import { Conversation } from 'ts-components/Conversation';

const BUSINESS_GENERATION_STEPS = (t: any) => [
  {
    title: t('Provide Requirements'),
  },
  {
    title: t('Build Your App'),
  },
  {
    title: t('Refine & Use'),
  },
];

const BusinessBuilderChild: FC = () => {
  const isMobile = useBreakpoint();
  const { t } = useTranslation();

  return (
    <BusinessBuilderContainer isMobile={isMobile}>
      <Conversation
        entityName={t('App')}
        isMobile={isMobile}
        flowType="business_builder"
        taskType="business_strategic_plan_generation"
        topPadding={20}
        header={({
          currentStep,
          isGenerationStarted,
          flowStatus,
          isStartGenerationLoading,
        }) => {
          return (
            <>
              <Header isMobile={isMobile}>
                <PageToolbarTitle>
                  {t('Generative AI CoBuilder')}
                </PageToolbarTitle>
              </Header>
              {!isMobile ? (
                <StepperWrapper>
                  <PerformKizenStepper
                    steps={BUSINESS_GENERATION_STEPS(t)}
                    currentStep={currentStep}
                  />
                </StepperWrapper>
              ) : null}
              {isGenerationStarted ? (
                <BusinessGenerationSummary
                  isMobile={isMobile}
                  isStartGenerationLoading={isStartGenerationLoading}
                  flowStatusMetadata={flowStatus?.run_metadata}
                  labels={flowStatus?.labels}
                  flowStatus={flowStatus?.status}
                  createdAt={flowStatus?.created}
                />
              ) : null}
            </>
          );
        }}
      />
    </BusinessBuilderContainer>
  );
};

const BusinessBuilder: FC = () => {
  const { t } = useTranslation();
  const { aiBusinessGeneration } = useSelector(getSettingsAccess);

  if (!aiBusinessGeneration?.enabled) {
    const errorComponents = getErrorComoponents(t)[403];
    return (
      <ErrorMessage
        title={errorComponents.title}
        text={errorComponents.text}
        button={errorComponents.button}
        dashboard
        supportEmail={errorComponents.supportEmail}
        code
      />
    );
  }

  return <BusinessBuilderChild />;
};
export default BusinessBuilder;
